import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BaseEnvironment } from '@mkp/shared/models';
import { MetaTag, getAppMetaTags } from '@mkp/shared/util-app-config';
import { ENVIRONMENT_PROVIDER, getJobcloudBrand } from '@mkp/shared/util-environment';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

const getDeepestRoute = (route: ActivatedRoute): ActivatedRoute =>
  route.firstChild ? getDeepestRoute(route.firstChild) : route;

const getMetaTags = (environment: BaseEnvironment): MetaTag[] => {
  const tags = getAppMetaTags(environment);
  return environment.name !== 'local' && environment.name !== 'qa'
    ? tags[environment.name]
    : tags.stage;
};

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly translateService = inject(TranslateService);
  private readonly metaService = inject(Meta);
  private readonly titleService = inject(Title);
  private readonly metaTags = getMetaTags(inject(ENVIRONMENT_PROVIDER));

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        if (!this.router.url.startsWith('/cms/')) this.updateTitle();
      });
  }

  updateTitle = (): void => {
    const deepestRoute = getDeepestRoute(this.activatedRoute.root);
    const routeTitle = deepestRoute.snapshot.data?.['title'];
    this.titleService.setTitle(
      routeTitle ? this.translateService.instant(routeTitle) : getJobcloudBrand()
    );
  };

  updateMetaTags = (): void => {
    this.metaTags.forEach(({ name, content }) =>
      this.metaService.updateTag({ name, content: this.translateService.instant(content) })
    );
  };
}
